import { useState } from "react";
import { FaMinus, FaPlus } from "react-icons/fa6";
import { Link } from "react-router-dom";

import { PAGE_NAME_HOW_TO_FIX } from "../../../../constants/common_constants";
import {
  IInferenceFactorType,
  IReferenceInfoType,
} from "../types/inference_factor_type";
import { v4 as uuidv4 } from "uuid";

// アコーディオンメニューコンポーネントに渡すprops
interface InferenceFactorAccordionListsProps {
  inferenceFactor: IInferenceFactorType;
  children?: React.ReactNode;
}

/**
 * アコーディオンメニューを表示するコンポーネント(リスト取得対応版)
 * @param inferenceFactor - 推定要因項目
 * @param children - 子要素
 * @returns JSX.Element - アコーディオンメニューの表示
 */
export const InferenceFactorAccordionLists = ({
  inferenceFactor,
  children,
}: InferenceFactorAccordionListsProps) => {
  // メニューが開いているかどうかを格納
  const [open, setOpen] = useState(false);

  // リストの開閉をトグル処理
  const toggleButton = () => {
    setOpen((prevState) => !prevState);
  };
  const handleJumpToAnotherTabLink = (reference: string, title: string) => {
    const keyId = uuidv4();
    const refKey = `reference_${keyId}`;
    //LocalStorageにマニュアルリンク, タイトル(参照情報のラベル)を保存する
    localStorage.setItem(refKey, reference);
    localStorage.setItem("title", title);
    //一時的に<a>タグを作成して別タブでリンクを開く
    const link = document.createElement("a");
    link.target = "_blank";
    link.href = `/${PAGE_NAME_HOW_TO_FIX}/${keyId}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // 参照情報(3階層目)をレンダリングする関数
  const renderReferences = () => {
    const referenceArray =
      inferenceFactor.issueFactor.repairFactor.referenceInfo;
    return referenceArray.map(
      (referenceInfo: IReferenceInfoType, index: number) => (
        <dd className="contents" key={referenceInfo.label}>
          <div
            className={`flex items-center ${
              index + 1 !== referenceArray.length && "border-b"
            } border-gray-700 py-2 pl-16 pr-4`}
          >
            {referenceInfo.reference ? (
              referenceInfo.reference.includes("http") ? (
                // referenceに入っている文字列にhttpが入っていた場合(外部リンクの場合),
                // 青文字でlabelを返し別タブでそのURLを開くリンクをつける
                <Link
                  to={referenceInfo.reference}
                  target="_blank"
                  rel="noopener noreferrer"
                  // className="text-sub-blue line-clamp-2"
                  className="text-sub-blue"
                >
                  {referenceInfo.label}
                </Link>
              ) : (
                // referenceに文字列が入っていた場合(ページ遷移の場合),
                // 青文字でlabelをそのページに遷移するリンクをつける
                <button
                  // className="text-left text-sub-blue line-clamp-2"
                  className="text-left text-sub-blue"
                  onClick={() =>
                    handleJumpToAnotherTabLink(
                      referenceInfo.reference,
                      referenceInfo.label
                    )
                  }
                >
                  {referenceInfo.label}
                </button>
              )
            ) : (
              //  referenceに何もない場合, 黒文字のままlabelを返す
              // <p className="line-clamp-2">{referenceInfo.label}</p>
              <p>{referenceInfo.label}</p>
            )}
          </div>
        </dd>
      )
    );
  };

  // ラベル部分(1・2階層目)をレンダリングする関数
  const renderMenu = () => {
    // childrenの有無によって表示するラベルの取得方法分岐
    const label = children
      ? inferenceFactor.issueFactor.label // (label = 要因項目)
      : inferenceFactor.issueFactor.repairFactor.label; // (label = 解決方法)

    return (
      <div
        // className={`grow line-clamp-2 cursor-pointer`}
        className="grow cursor-pointer"
        onClick={toggleButton}
      >
        {label}
      </div>
    );
  };

  // 各リスト部分をレンダリングする関数
  const renderList = () => {
    return (
      <div>
        <dt
          className={`flex items-center justify-between border-gray-700 cursor-pointer py-2 ${
            children ? "pl-3" : "pl-8"
          } ${open && "border-b"} pr-3`}
        >
          <div className="pr-3 cursor-pointer" onClick={toggleButton}>
            {open ? <FaMinus /> : <FaPlus />}
          </div>
          {renderMenu()}
          {/* {children && (
            // 一番上のリストの場合のみ処理
            <p className="pl-2 text-end">
              {(inferenceFactor.issueFactor.probability * 100).toFixed(2)}%
            </p>
          )} */}
        </dt>
        {open && (children || renderReferences())}
      </div>
    );
  };

  return (
    <dl
      className={`bg-white rounded  border-gray-700 ${
        children ? "border mb-4" : ""
      }`}
    >
      {renderList()}
    </dl>
  );
};
